import { CustomBox } from "@/common/StyledComponents";
import { Button, Modal, useTheme } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import InvoiceFormMulti from "@/vendor/InvoiceFormMulti";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectOrganizationPublicId } from "@/auth/authSlice";
import { selectProjectCurrency, selectProjectDocket } from "./actualSlice";

export default function AccountingBillUploadPopup({ getProject }) {
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const publicId = useSelector(selectOrganizationPublicId);
    const projectDocket = useSelector(selectProjectDocket);
    const handleSuccess = () => {
        setOpen(false);
        getProject();
    };
    return (
        <>
            <Button
                variant="contained"
                startIcon={<EditOutlinedIcon />}
                onClick={() => setOpen(true)}
            >
                Add Bills
            </Button>
            <Modal open={open} onClose={() => setOpen(false)}>
                <CustomBox
                    sx={{
                        background: theme.palette.background.default,
                        width: "80vw",
                        overflowY: "auto",
                    }}
                >
                    <InvoiceFormMulti
                        publicId={publicId}
                        projectDocket={projectDocket}
                        onSuccess={handleSuccess}
                    />
                </CustomBox>
            </Modal>
        </>
    );
}
